export default "__VITE_ASSET__adb5804b__"